import React, { createContext, useContext, useState, useEffect } from 'react';
import { Station } from '../types/Station';
import { fetchStations } from '../api/apis';

const StationsContext = createContext<Station[]>([]);

export const StationsProvider = ({ children }: { children: React.ReactNode }) => {
  const [stations, setStations] = useState<Station[]>([]);

  useEffect(() => {
    const loadStations = async () => {
      const fetchedStations = await fetchStations();
      setStations(fetchedStations);
    };
    loadStations();
  }, []);

  return (
    <StationsContext.Provider value={stations}>
      {children}
    </StationsContext.Provider>
  );
};

export const useStations = () => useContext(StationsContext); 